import { render, staticRenderFns } from "./CategoryView.vue?vue&type=template&id=2416daaa&scoped=true&"
import script from "./CategoryView.vue?vue&type=script&lang=js&"
export * from "./CategoryView.vue?vue&type=script&lang=js&"
import style0 from "./CategoryView.vue?vue&type=style&index=0&id=2416daaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2416daaa",
  null
  
)

export default component.exports